import { render, staticRenderFns } from "./returnStorehouseApplyManageList.vue?vue&type=template&id=c6abd1f8&scoped=true"
import script from "./returnStorehouseApplyManageList.vue?vue&type=script&lang=js"
export * from "./returnStorehouseApplyManageList.vue?vue&type=script&lang=js"
import style0 from "./returnStorehouseApplyManageList.vue?vue&type=style&index=0&id=c6abd1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6abd1f8",
  null
  
)

export default component.exports